module.exports = __webpack_public_path__ + "static/media/loginbackground.77a6178a.svg";